import { SelectOption } from '@/components/Select'
import { ASSIGNABLE_ROLE_OPTIONS } from '@/constants/enterprise'

/**
 * Self-edits intentionally disallow selecting "member" to ensure admins can
 * only move between admin-level roles (admin <-> it_admin) on themselves.
 */
export const getAssignableRoleOptions = (selfEdit: boolean): SelectOption[] => {
  if (!selfEdit) return ASSIGNABLE_ROLE_OPTIONS
  return ASSIGNABLE_ROLE_OPTIONS.filter((option) => option.value !== 'member')
}
